<onyx-modal
  variant="right"
  [heading]="vehicle() ? (vehicle() | fleetIdentifier) : ''"
  [loading]="loading()"
  [(error)]="error"
  [close$]="close$"
  (errorChange)="vehicle$.next()"
  (closeModal)="dialogRef.close()"
>
  <ng-container headingButtons>
    @if (vehicle(); as vehicle) {
      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="map-view-outlined"
        [circle]="true"
        onyxTooltip="labels.showOnMap"
        (click)="showOnMap()"
      ></onyx-icon-button>

      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="gantt-outlined"
        [circle]="true"
        onyxTooltip="labels.showOnGantt"
        (click)="showOnGantt()"
      ></onyx-icon-button>

      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="share-outlined"
        [circle]="true"
        onyxTooltip="labels.share"
        (click)="share()"
      ></onyx-icon-button>

      <onyx-icon-button
        data-testid="options-button"
        variant="transparent"
        color="gray"
        [size]="32"
        icon="options-vertical-filled"
        [circle]="true"
        [onyxDropdownOptions]="options()"
        [onyxDropdownDisabled]="!options()?.length"
        onyxDropdownMaxHeight="fill"
        (onyxDropdownSelectedValueChange)="$event.value?.()"
        onyxTooltip="labels.options"
        (click)="$event.stopPropagation()"
      ></onyx-icon-button>
    }
  </ng-container>

  <ng-container titleLeftOptions>
    @if (vehicle(); as vehicle) {
      <onyx-icon
        [name]="`${vehicle.generalInformation.category}-filled`"
        [size]="20"
        [onyxTooltip]="`${isVehicle() ? DictionaryCode.VEHICLE_CATEGORY : DictionaryCode.TRAILER_CATEGORY}.${vehicle.generalInformation.category}`"
      ></onyx-icon>
    }
  </ng-container>

  <ng-container titleRightOptions>
    @if (vehicle()?.additionalParameters?.isLowDeck != null) {
      <onyx-icon
        class="f-muted"
        name="low-deck-filled"
        [size]="20"
        onyxTooltip="labels.lowDeck"
      ></onyx-icon>
    }

    @if (semiTrailerHeaderConfig(); as config) {
      <onyx-icon
        class="f-muted"
        [name]="config.icon"
        [size]="16"
        [onyxTooltip]="`${DictionaryCode.SEMI_TRAILER_SIZE}.${config.size}`"
      ></onyx-icon>
    }
  </ng-container>

  <ng-container description>
    @if (vehicle(); as vehicle) {
      <app-fleet-modal-header-description
        [vehicle]="vehicle"
      ></app-fleet-modal-header-description>
    }
  </ng-container>

  @if (vehicle(); as vehicle) {
    <div class="container">
      <app-fleet-modal-warnings
        [vehicle]="vehicle"
        [close$]="close$"
        (redirectToDocuments)="redirectToDocuments()"
        (redirectToDetails)="redirectToDetails()"
      ></app-fleet-modal-warnings>

      @defer (when assignedVehicle() !== undefined) {
        <div class="chips-container">
          <onyx-chips
            [chips]="sections()"
            variant="tertiary"
            [single]="true"
            [wrap]="true"
            [gap]="8"
            [(activeValues)]="section"
          ></onyx-chips>

          @switch (section()[0]) {
            @case (FleetModalSection.SUMMARY) {
              <app-fleet-modal-summary
                [vehicle]="vehicle"
                [assignedVehicle]="assignedVehicle()"
                [order]="order()"
                [orderLoading]="orderLoading()"
                [orderError]="orderError()"
                [close$]="close$"
                [order$]="order$"
                [assignedVehicleLoading]="assignedVehicleLoading()"
                [assignedVehicleError]="assignedVehicleError()"
                [assignedVehicle$]="assignedVehicle$"
              ></app-fleet-modal-summary>
            }
            @case (FleetModalSection.DETAILS) {
              <app-fleet-modal-details
                [vehicle]="vehicle"
                [isVehicle]="isVehicle()!"
                [close$]="close$"
              ></app-fleet-modal-details>
            }
            @case (FleetModalSection.DOCUMENTS) {
              <app-fleet-modal-documents
                [vehicle]="vehicle"
              ></app-fleet-modal-documents>
            }
            @case (FleetModalSection.NOTE) {
              <app-modal-note
                [note]="vehicle.note"
                [route]="FleetRoute.EDIT_FLEET.replace(':uuid', vehicle.uuid)"
                [close$]="close$"
              ></app-modal-note>
            }
          }
        </div>
      }
    </div>
  }
</onyx-modal>
